import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Table = styled.table(props => ({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",
    borderWidth: 0,

    td: {
        verticalAlign: "baseline",
        padding: "20px 5px 0",
        fontSize: theme(props).typography.primary.fontSize.css(),
        lineHeight: "22px",
        whiteSpace: "normal",
        // NOTE wordWrap: "break-word" нужна для только IE11 (https://stackoverflow.com/questions/1258416/word-wrap-in-an-html-table)
        wordWrap: "break-word",
    },
}));
